/* eslint-disable no-unused-vars */
import React from "react";
import EditCell from "../EditableCell";
import { ACCESSORS } from "../../../../constants";
import Tooltip from "@mui/material/Tooltip";
import { getText } from "../EditableCell/constants";
import { Wrapper } from "./styled";

const LotAmount = ({ handleChange, row, defVal }) => {
  if (!row.original.inputs.showLotAmount) {
    return null;
  }

  return (
    <Tooltip
      placement="right-start"
      title={getText(row.original.pricePerLot)}
    >
      <Wrapper>
        <EditCell handleChange={handleChange} row={row} name={ACCESSORS[5]} defVal={defVal} />
      </Wrapper>
    </Tooltip>
  );
};

export default LotAmount;
